<template>
	<div>
		<Header></Header>
		<Search></Search>
		<Nav></Nav>
		<div class="allsort">
			<div class="w">
				<div class="allsortcon clearfloat d-flex">
					<div class="allsortleft">
						<div class="allsortup clearfloat" @click="catTab(-1)">
							<i><img src="../../assets/images/allicon.png" alt=""></i>
							<span>全部分类</span>
						</div>
						<div class="allsortbut">
							<ul>
								<template v-for="(item,index) in cat_list">
									<li @click="catTab(index)" :class="{'active' : cat_active == index}"><span v-text="item.name"></span></li>
								</template>
							</ul>
						</div>
					</div>
					<div class="allsortright">
						<div class="allsortrightcon">
							<template v-for="(item, index) in cat_list">
								<div class="allsortlist" v-show="cat_active == -1 || cat_active == index">
									<h4 class="sortitle" v-text="item.name"></h4>
									<div class="allsortlisted" v-if="item.child && item.child.length">
										<div class="allsortlistedcon clearfloat" v-for="(secondItem, secondIndex) in item.child" :key="secondIndex">
											<h5 v-text="secondItem.name+' &gt;'" @click="catClick(secondItem.id)"></h5>
											<div class="allsortlistright" v-if="secondItem.child && secondItem.child.length">
												<template v-for="(thirdItem, thirdIndex) in secondItem.child">
													<p v-text="thirdItem.name" @click="catClick(thirdItem.id)"></p>
												</template>
											</div>
										</div>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Search from "@/components/search/search";
	import Nav from "@/components/nav/nav";
	import Foot from "@/components/foot/foot";
	export default {
		components: {
			Search,
			Header,
			Nav,
			Foot,
		},
		data() {
			return {
				cat_active: -1,
				cat_is: 0,
				cat_list: []
			};
		},
		created() {
			this.getCatList();
		},
		methods: {
			// 获取分类列表
			getCatList() {
				let params = {cat_id: this.cat_id};
				this.$loading();
				this.$api
					.allCategories(params)
					.then((res) => {
						if(res.code == 0){
							this.$loading().close();
							this.cat_list = res.data;
							console.log(res.data)
						}
					})
					.catch((err) => {
						this.common.message(this,err);
					});
			},
			// 一级分类切换
			catTab(index) {
				this.cat_active = index;
			},
			// 点击分类跳转列表
			catClick(id) {
				this.$router.push({
					path: '/list',
					query: {
						id: id
					}
				})
			},
		},
	};
</script>

<style lang="scss" scoped>
	.allsort{
		width: 100%;
		height: 100%;
		background: #F2F2F2;
		padding: 20px 0 42px 0;
		box-sizing: border-box;
		.allsortcon{
			width: 100%;
			.allsortleft{
				float: left;
				width: 190px;
				background: #fff;
				margin-right: 10px;
				.allsortup{
					cursor: pointer;
					width: 100%;
					height: 50px;
					background: #FF0E25;
					padding-top: 17px;
					padding-left: 18px;
					box-sizing: border-box;
					i{
						float: left;
						width: 16px;
						height: 16px;
						margin-right: 6px;
						img{
							display: block;
						}
					}
					span{
						float: left;
						font-size: 16px;
						color: #fff;
						font-weight: 500;
						line-height: 16px;
					}
				}
				.allsortbut{
					width: 100%;
					ul{
						li{
							width: 100%;
							height: 44px;
							padding: 0 20px 0 30px;
							box-sizing: border-box;
							cursor: pointer;
							transition: .5s;
							-moz-transition: .5s;
							-webkit-transition: .5s;
							-o-transition: .5s;
							span{
								display: block;
								font-size: 16px;
								overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
								color: #333;
								font-weight: 400;
								line-height: 44px;
								transition: .5s;
								-moz-transition: .5s;
								-webkit-transition: .5s;
								-o-transition: .5s;
							}
							&:hover{
								background: #EBEBEB;
							}
							&.active{
								background: #EBEBEB;
							}
						}
					}
				}
				
			}
			.allsortright{
				float: right;
				width: 990px;
				.allsortrightcon{
					width: 100%;
					.allsortlist{
						width: 100%;
						background: #fff;
						padding: 22px 23px;
						box-sizing: border-box;
						margin-bottom: 20px;
						&:last-child{margin-bottom: 0;}
						.sortitle{
							width: 100%;
							font-size: 16px;
							color: #000;
							font-weight: 400;
							line-height: 16px;
							border-left: 2px solid #FF0E25;
							padding-left: 8px;
							box-sizing: border-box;
							margin-bottom: 10px;
						}
						.allsortlisted{
							width: 100%;
							.allsortlistedcon{
								width: 100%;
								padding: 10px 0 2px 0;
								border-bottom: 1px solid #EFEFEF;
								box-sizing: border-box;
								h5{
									cursor: pointer;
									float: left;
									font-size: 12px;
									color: #FF0E25;
									font-weight: 400;
									line-height: 17px;
									max-width: 100px;
									min-width: 75px;
									text-align: left;
									font: 12px consolas;
									margin-bottom: 8px;
								}
								.allsortlistright{
									float: left;
									width: 89%;
									padding-left: 22px;
									box-sizing: border-box;
									p{
										float: left;
										margin: 0 8px 8px 8px;
										font-size: 12px;
										color: #999;
										font-weight: 400;
										line-height: 17px;
										cursor: pointer;
										position: relative;
										transition: .5s;
										-moz-transition: .5s;
										-webkit-transition: .5s;
										-o-transition: .5s;
										&::before{
											content: '';
											width: 1px;
											height: 13px;
											background: #EFEFEF;
											position: absolute;
											top: 2px;
											right: -8px;
										}
										&:last-child::before{display: none;}
										&:hover{color: #FF0E25;}
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>
